import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP code/migrations — see metadata.md grounding note.
// Anchor narrative: docs/visual-companion/2026-05-24-honest-reality-check.html.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "I built a multi-tenant enterprise RAG system solo. The hard part wasn't the features — it was making it trustworthy." },
];

export const NINETY: ScriptLine[] = [
  { scene: "ninety", fromSec: 0.4, holdSec: 6, caption: "Ingest, chunk, pgvector, hybrid search, an MCP server, missions, agents — that's the 90%. It's mostly known patterns." },
  { scene: "ninety", fromSec: 6.6, holdSec: 6.5, caption: "You can wire that in weeks. A demo that answers questions looks finished. It isn't." },
];

export const FAILURE: ScriptLine[] = [
  { scene: "failure", fromSec: 0.4, holdSec: 6, caption: "The last 10% is the part that almost shipped a confident lie to a stakeholder." },
  { scene: "failure", fromSec: 6.6, holdSec: 6.5, caption: "A mission once fabricated a stat — \"93,000+\" — that existed in zero source documents." },
  { scene: "failure", fromSec: 13.4, holdSec: 3.5, caption: "Fluent. Cited. Completely made up." },
];

export const GROUNDING: ScriptLine[] = [
  { scene: "grounding", fromSec: 0.4, holdSec: 6, caption: "So I made fabrication a hard error. Migration 187 attaches a grounding contract to fact-making missions." },
  { scene: "grounding", fromSec: 6.6, holdSec: 6.5, caption: "numeric_grounding: 'hard_block' — any number with no source in the retrieved context fails the draft." },
  { scene: "grounding", fromSec: 13.4, holdSec: 4, caption: "Not a prompt asking nicely. A check that blocks." },
];

export const GATE: ScriptLine[] = [
  { scene: "gate", fromSec: 0.4, holdSec: 6, caption: "The same idea guards every outbound send: a verify-output gate sits in front of gmail-send." },
  { scene: "gate", fromSec: 6.6, holdSec: 6.5, caption: "When it refuses, record-gate-block logs the structured reason. 35 historical blocks, now in a real table." },
  { scene: "gate", fromSec: 13.4, holdSec: 2.5, caption: "Refused drafts are a feature, not a bug." },
];

export const PROBE: ScriptLine[] = [
  { scene: "probe", fromSec: 0.4, holdSec: 6, caption: "Then the subtle one: an answer can be faithful to its sources and still wrong — because it cited the stale doc." },
  { scene: "probe", fromSec: 6.6, holdSec: 6.5, caption: "Every grader passed it. A human caught it. So I wrote the missing signal: a recency-correctness probe." },
  { scene: "probe", fromSec: 13.4, holdSec: 4.5, caption: "Black-box, no LLM, 10 tests — it gates retrieval and survives a graph-backend swap." },
];

export const HONEST: ScriptLine[] = [
  { scene: "honest", fromSec: 0.4, holdSec: 6.5, caption: "And the discipline I learned the hard way: a UI shell over a no-op handler is not \"shipped.\"" },
  { scene: "honest", fromSec: 7.2, holdSec: 6.5, caption: "I once called a learning loop done — 11 of 12 nozzles were dry. I wrote it down so I'd stop doing it." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Features are table stakes. Trust is the product. The last 10% is where the actual work lives." },
  { scene: "outro", fromSec: 5.6, holdSec: 4, caption: "Next: the honest story — including the day my government blocked my database." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
